var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWishlistSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.274 16.238l-2.24 2.328a1.402 1.402 0 01-2.037-.008l-2.258-2.345c-.795-.826-.99-2.133-.38-3.104a2.298 2.298 0 013.635-.39c1.024-1.066 2.79-.924 3.638.419.618.976.43 2.28-.358 3.1z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.586 2.586A2 2 0 004 4v6.208a4.31 4.31 0 012.997.132c1.857-.774 4.129-.166 5.326 1.73 1.446 2.287.433 4.228-1.015 5.93H14a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6a2 2 0 00-1.414.586z",
    fill: "currentColor"
  })));
}
export default SvgWishlistSolid;